const NoticeText = () => {
    return (
        <div>
            <span style={{ opacity: .5, fontSize: 13, fontStyle: 'italic'}}> ⚠️ Please don't refresh, go back or close the browser, this may erase your progress and your information may be lost.</span>
        </div>
    );
}
 
export default NoticeText;